import { CSSTransition } from 'react-transition-group';
import hardIcon from '~/assets/icons/currency_donate.svg';
import tickIcon from '~/assets/icons/tick.svg';
import { rage, useObservable } from '~/rage';
import { formatTime } from '~/shared';
import { useRemainingTime } from '../../hooks';
import { LineDecor } from '../LineDecor';
import {
	HOUR_MS,
	MIN_WIDTH_LONG_TIMER,
	MIN_WIDTH_RECEIVED,
	MIN_WIDTH_TIMER,
} from './PlaytimeReward.model';
import {
	StyledContainer,
	StyledLabel,
	StyledReward,
	StyledRewardAmount,
	StyledRewardLabel,
} from './PlaytimeReward.styled';

const PlaytimeReward: React.FC = () => {
	const reward = useObservable(rage.hud.getPlaytimeReward());

	const remaining = useRemainingTime(reward?.expiresAt ?? null);

	const isReceived = !!reward?.isReceived;
	const isLongTimer = remaining >= HOUR_MS;

	const minWidth = isReceived
		? MIN_WIDTH_RECEIVED
		: isLongTimer
		? MIN_WIDTH_LONG_TIMER
		: MIN_WIDTH_TIMER;

	return (
		<CSSTransition
			in={!!reward}
			classNames={'playtime-reward'}
			timeout={500}
			unmountOnExit
			appear
		>
			<StyledContainer $minWidth={minWidth}>
				{isReceived ? (
					<StyledLabel>Награда получена</StyledLabel>
				) : (
					<StyledLabel>
						Осталось:{' '}
						<span>
							{formatTime(
								remaining,
								isLongTimer ? '{hh}:{mm}:{ss}' : '{mm}:{ss}',
							)}
						</span>
					</StyledLabel>
				)}
				<StyledReward $isReceived={isReceived}>
					<StyledRewardAmount>
						{(reward?.amount ?? 0).toLocaleString('ru-RU')}
					</StyledRewardAmount>
					<img src={hardIcon} />
					<LineDecor $height={30} />
					{isReceived ? (
						<img src={tickIcon} />
					) : (
						<StyledRewardLabel>FREE</StyledRewardLabel>
					)}
				</StyledReward>
			</StyledContainer>
		</CSSTransition>
	);
};

export { PlaytimeReward };
